<template>
    <vTradeLineComponent v-if="flag" :postList="postList"></vTradeLineComponent>
</template>
<script>
import vTradeLineComponent from '../../listComponent/order/tradeLineComponent.vue';
export default {
    name: 'tradeLineList',
    components: {
        vTradeLineComponent
    },
    data() {
        return {
            flag: false,
            postList: {
                headerTitle: false,
                order_rid: true,
                order_name: true,
                product_rid: true,
                syncReceivableWriteOffStatusBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            }
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>